<template>
  <!-- 相关文献/文献研究 -->
  <div class="ddh-report" v-loading="loading">
    <el-empty v-if="!loading && !list.length"></el-empty>
    <ul v-else>
      <li v-for="(item, index) in list" :key="index">
        <a :href="item.nodeUrl" target="_blank">{{ item.title }}</a>
        <span>{{ item.time }}</span>
      </li>
      <p v-if="!loading && total>10"><a target="_blank" :href="`/#/more/${$route.params.uid ? $route.params.uid : uidList[$route.params.index]}/${breadcrumb}`">查看更多>></a></p>
    </ul>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      list: [],
      total:0,
      uidList:[],
      loading:false,
      breadcrumb:''
    };
  },
  created(){
    if(this.$route.params.index) this.getUidList()
    else this.getList(this.$route.params.uid)
  },
  methods: {
    getUidList() {
      this.axios
        .get(
          "data/custom/classType?uid=487c1060-6112-498a-b13c-a8e9c9129e82&pageNum=1&pageSize=10"
        )
        .then((res) => {
          if (res.status == 200) {
            this.uidList = res.data.rows.map((item) => item.uid);
            this.getList();
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    getList(uid){
      this.loading = true
      this.breadcrumb = this.$route.params.uid ? `十九大以来的历次全会>${this.$route.params.activeName}` : `历次党代会>${this.$route.params.activeName}`
      this.axios.post("data/cnki/getKbaseList",{
        uid: uid || this.uidList[this.$route.params.index],
        pageNum: 1,
        pageSize: 10,
        sign:'更多'
      }).then((res) => {
        this.loading = false
        if (res.status == 200) {
          this.total = res.data.total
          this.list = res.data.rows;
        } else {
          this.$message.error("获取失败！");
        }
      });
    }
  },
};
</script>
  
  <style lang="scss" scoped>
.ddh-report {
  width: 922px;
  height: aoto;
  background: url("../../assets/images/dnhd-dwbg.png") no-repeat;

  ul {
    width: 922px;
    height: 416px;
    margin-top: 15px;
    box-sizing: border-box;
    padding: 16px 30px 0 30px;
    li {
      position: relative;
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      line-height: 40px;
      a {
        margin-left: 18px;
      }
    }
    li:before {
      position: absolute;
      top: 14px;
      content: "";
      display: inline-block;
      width: 8px;
      height: 12px;
      background: url("../../assets/images/vector.png") no-repeat;
    }
    p {
      text-align: right;
      font-size: 16px;
      margin-top: 10px;
      a {
        color: #9f9fa6;
      }
    }
  }
}
</style>